import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";
import { btnBrand } from "@/lib/academyFormat";
import { ACADEMY } from "@/constants/testIds";

// Fix U (2026-10-13): alta o edicion de los datos de contacto de un alumno.
export default function StudentModal({ open, onOpenChange, student, onSaved }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", notes: "" });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const isEdit = Boolean(student);

  useEffect(() => {
    if (!open) return;
    setError("");
    setForm(student ? { name: student.name || "", email: student.email || "", phone: student.phone || "", notes: student.notes || "" }
      : { name: "", email: "", phone: "", notes: "" });
  }, [open, student]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    if (form.name.trim().length < 2 || !form.email.trim() || form.phone.trim().length < 6) {
      setError("Nombre, email y teléfono son obligatorios");
      return;
    }
    setSaving(true);
    setError("");
    const body = { name: form.name.trim(), email: form.email.trim(), phone: form.phone.trim(), notes: form.notes.trim() || null };
    try {
      const { data } = isEdit ? await api.put(`/academy/students/${student.id}`, body) : await api.post("/academy/students", body);
      onSaved(data);
      onOpenChange(false);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid={ACADEMY.studentModal}>
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">{isEdit ? "Editar alumno" : "Nuevo alumno"}</DialogTitle>
          <DialogDescription className="sr-only">Datos de contacto del alumno</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Nombre</Label>
            <Input value={form.name} onChange={set("name")} data-testid={ACADEMY.studentNameInput} />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <Label className="text-sm text-muted-foreground mb-1 block">Email</Label>
              <Input type="email" value={form.email} onChange={set("email")} data-testid={ACADEMY.studentEmailInput} />
            </div>
            <div>
              <Label className="text-sm text-muted-foreground mb-1 block">Teléfono (WhatsApp)</Label>
              <Input value={form.phone} onChange={set("phone")} data-testid={ACADEMY.studentPhoneInput} />
            </div>
          </div>
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Notas</Label>
            <Input value={form.notes} onChange={set("notes")} placeholder="Opcional" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid={ACADEMY.modalError}>{error}</p>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button className={btnBrand} onClick={save} disabled={saving} data-testid={ACADEMY.studentSaveButton}>{saving ? "Guardando..." : "Guardar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
